import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { parse } from 'qs'
import { useIntl } from 'react-intl'
import { withStyles } from '@mui/styles'
import { Box, Container, Typography } from '@mui/material'

import { getJCAs } from '../../slices'
import { JCATable } from '../table'
import { JCAFilter } from '../filter'
import { jcaDashboardStyles } from './jca-dashboard.styles'
import { JCA_DEFAULT_QUERY } from '../../constants'

export const JCADashboard = withStyles(jcaDashboardStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const global = useSelector((state) => state.global)
  const url = useLocation().search
  const urlSearchParams = parse(url.split('?')[1])
  const searchParams = {
    ...JCA_DEFAULT_QUERY,
    ...urlSearchParams,
  }
  const isGuild = !!global.gremio

  useEffect(() => {
    dispatch(getJCAs(searchParams, isGuild))
  }, [url]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <Container className={classes.container} maxWidth="xl">
        <Box mb={2}>
          <Typography variant="h4" color="textSecondary">
            {formatMessage({ id: 'pages.jcaList.title' })}
          </Typography>
        </Box>
        <Box mb={2}>{<JCAFilter />}</Box>
        <Box>
          <JCATable />
        </Box>
      </Container>
    </Box>
  )
})
